import { cubicOut } from "svelte/easing";

export function scaleY(node, {
	delay = 0,
	duration = 400,
	easing = cubicOut,
	start = 0
})
{
	const style = getComputedStyle(node);
	const transform = style.transform === 'none' ? '' : style.transform;

	const sd = 1 - start;

	return {
		delay,
		duration,
		easing,
		css: (_t, u) => `
			transform: ${transform} scaleY(${1 - (sd * u)});
      transform-origin: top left;
		`
	};
}